/**
 * URL patterns Sentry should ignore when deciding whether to report an error.
 *
 * Sentry evaluates `denyUrls` against each frame's URL in the stack trace —
 * an event is dropped when any frame URL matches any entry in the list.
 */
export const sentryDenyUrls: RegExp[] = [
  // Filter out noise from Facebook's in-app browser (IAB). When the IAB
  // closes, Facebook's injected navigation_performance_logger_android
  // script fires a teardown handler after the Java bridge has already been
  // released, causing an unhandled "Java object is gone" error that
  // originates entirely within Facebook's own injected code (iabjs://
  // scheme) and does not reflect any issue in our application.
  /^iabjs:\/\//,
  // Filter out errors originating from browser extensions. These errors
  // are thrown inside the extension's own sandboxed scripts (e.g.
  // chrome-extension:// or moz-extension://) and are not caused by our
  // application code. They appear when third-party extensions (crypto
  // wallets, ad-blockers, etc.) interact with pages they are injected
  // into, and produce false-positive noise in our Sentry queue.
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
  // Filter out errors originating from Google Tag Manager scripts. GTM
  // loads and fires third-party ad/analytics tags (e.g. DoubleClick) whose
  // network requests can be blocked by ad-blockers or browser extensions,
  // producing unhandled "Failed to fetch" rejections with stack frames that
  // point to the GTM script or DoubleClick endpoints. These errors originate
  // entirely within GTM's own injected code and do not reflect any issue in
  // our application.
  /^https?:\/\/www\.googletagmanager\.com\//,
  /^https?:\/\/[^/]*\.doubleclick\.net\//,
  /^https?:\/\/[^/?#\\]*\.cookielaw\.org\//,
  /^https?:\/\/[^/?#\\]*\.onetrust\.com\//,
];
